import React from 'react';
import ErrorTemplate from './ErrorTemplate';

const messageToDisplay = (code: string) => {
  return (
    <>
      Error en la carga de datos, inténtelo
      <br />
      nuevamente o recargue la página.
      <br />
      Código: {code}
    </>
  );
};

const ErrorPage = ({
  functionToReload,
  code,
}: {
  readonly functionToReload: () => void;
  code: string;
}) => {
  return (
    <ErrorTemplate
      hasReloadButton={true}
      reload={functionToReload}
      message={messageToDisplay(code)}
    />
  );
};

export default ErrorPage;
